import { Col } from 'antd'
import styled from 'styled-components'

import { INGREDIENT_TREE_FIELD_MIN_HEIGHT } from '../../constants'

const StyledIngredientKeywordsColumn = styled(Col)`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  padding-top: 10px;
  min-height: ${INGREDIENT_TREE_FIELD_MIN_HEIGHT}px;
`

export default StyledIngredientKeywordsColumn
